import { IS_SMALL_SCREEN } from '@Constants/LeftDrawer';
import { AntDesign } from '@expo/vector-icons';
import { observer } from 'mobx-react-lite';
import React, { useCallback } from 'react';
import { StyleSheet, useWindowDimensions } from 'react-native';
import HTML from 'react-native-render-html';
import styled from 'styled-components/native';

import OwnableTheme from '../../../assets/OwnableTheme';
import { Text } from '../../Common/Text';
import { useProductDescriptionPresenter } from './ProductDescriptionPresenter';

import externalLinkService from '~gateways/external-link';

const StyledDescription = styled.View`
  width: 100%;
`;

const ViewDetailsWrapper = styled.Pressable`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 8px;
  align-items: center;
  margin-bottom: 10px;
  padding-top: ${IS_SMALL_SCREEN ? 10 : 20}px;
`;

const baseFontStyle = {
  fontFamily: OwnableTheme.fonts.gilroy.regular,
  color: '#333',
};

const tagsStyles = {
  p: {
    marginBottom: IS_SMALL_SCREEN ? 10 : 16,
    fontSize: IS_SMALL_SCREEN ? 10 : 14,
    lineHeight: IS_SMALL_SCREEN ? 12 : 18,
  },
  br: {
    display: 'block',
    height: IS_SMALL_SCREEN ? 10 : 16,
    marginBottom: IS_SMALL_SCREEN ? 10 : 16,
  },
  ul: {
    marginTop: IS_SMALL_SCREEN ? 10 : 16,
    fontSize: IS_SMALL_SCREEN ? 10 : 14,
  },
};

const ProductDescription = ({ html }: { html: string }) => {
  const onLinkPressCallback = useCallback((_: any, href: string) => {
    externalLinkService.openUrl(href);
  }, []);

  const { detailsVisible, onTogglePress } = useProductDescriptionPresenter();

  const { height } = useWindowDimensions();
  const isLargeLayout = height > 735;
  const marginTop = isLargeLayout ? 0 : -32;

  return (
    <StyledDescription style={{ marginTop }}>
      <ViewDetailsWrapper
        onPress={onTogglePress}
        style={[
          styles.detailsWrapper,
          { borderTopColor: OwnableTheme.colors.darkGray },
        ]}
      >
        <Text
          color={OwnableTheme.colors.black}
          size={IS_SMALL_SCREEN ? 'x4s' : 'xs'}
        >
          View details
        </Text>
        {detailsVisible.value ? (
          <AntDesign
            name='down'
            size={IS_SMALL_SCREEN ? 10 : 16}
            color={OwnableTheme.colors.black}
          />
        ) : (
          <AntDesign
            name='right'
            size={IS_SMALL_SCREEN ? 10 : 16}
            color={OwnableTheme.colors.black}
          />
        )}
      </ViewDetailsWrapper>
      {detailsVisible.value && (
        <HTML
          html={html}
          baseFontStyle={baseFontStyle}
          tagsStyles={tagsStyles}
          onLinkPress={onLinkPressCallback}
        />
      )}
    </StyledDescription>
  );
};

export default observer(ProductDescription);

const styles = StyleSheet.create({ detailsWrapper: { borderTopWidth: 0.5 } });
